module.exports = __webpack_public_path__ + "static/media/card-American-Express.65ca9b2e.svg";